/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// require('react-datetime/css/react-datetime.css')

// polyfills for phantomjs (which we should stab and kick)
// import "babel-polyfill"
// import 'core-js/es6/map';
// import 'core-js/es6/set';
// import 'core-js/fn/array/find';
// import 'core-js/fn/array/includes';
// import 'core-js/fn/number/is-nan';

import React from 'react'
import ReactDOM from 'react-dom'
import SaleProductShow from 'sale_products/sale_product_show'

const breakpoint = 991

document.addEventListener('DOMContentLoaded', () => {
  const queryResponse = JSON.parse(document.getElementById('sale_product_variants_react_data').getAttribute('data-query-response'))
  
  const contentTags = [...document.getElementsByClassName('sale_product_variants_react_portal')]
  const small = contentTags.find(tag => tag.classList.contains('small-screen'))
  const large = contentTags.find(tag => tag.classList.contains('large-screen'))

  const initialMount = window.innerWidth <= breakpoint ? small : large
  ReactDOM.render(<SaleProductShow queryResponse={queryResponse} />, initialMount)
    
  const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`)
  mediaQuery.addEventListener('change', () => {
    let toMount, toUnmount

    if (window.innerWidth <= breakpoint) {
      toMount = small
      toUnmount = large
    } else {
      toMount = large
      toUnmount = small
    }

    ReactDOM.unmountComponentAtNode(toUnmount)
    ReactDOM.render(<SaleProductShow queryResponse={queryResponse} />, toMount)
  })
})
